let authModule = angular.module('app.auth', []);

require('./auth-service');
require('./auth-interceptor');

export default authModule;



// WEBPACK FOOTER //
// ./app/auth/_index.js